module.exports = __webpack_public_path__ + "static/media/deeplearning_ai_logo.75a7107b.png";